import React from 'react'
import { chain, values } from 'lodash'
import { connect } from "react-redux"

import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'
import { ModalTagsSelector } from './TagsSelector'
import ModalTagsEditor from './ModalTagsEditor'

import "./tags.less"

export const SimpleTagsList = ({ selectedTags, allTags }) => (
  <i>
    {
      chain(selectedTags)
        .keys()
        .filter(id => selectedTags[id])
        .map(id => `#${(allTags[id] || {}).name}`)
        .value()
        .join(", ")
    }
  </i>
)

export const ConnectedSimpleTagsList = connect(
  state => ({
    allTags: state.tags
  })
)(SimpleTagsList)

/* */

type Props = {
  selectedTags: { [string]: boolean },
  onChange: { [string]: boolean } => void,
  allTags: Object,
  onClick: ?(string => void),
  tagType: string
}

class TagsList extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { modal: null }
  }

  props: Props

  render() {
    const selectedTags = values(this.props.allTags).filter(tag => this.props.selectedTags[tag._id])

    return (
      <div className="TagsList">
        {
          this.state.modal == "select" && (
            <ModalTagsSelector
              allTags={this.props.allTags}
              selectedTags={this.props.selectedTags || {}}
              onChange={newSelection => this.props.onChange(newSelection)}
              onEditClick={() => this.setState({ modal: "edit" })}
              onClose={() => this.setState({ modal: null })}
              tagType={this.props.tagType}
            />
          )
        }

        {
          this.state.modal == "edit" && (
            <ModalTagsEditor
              tagType={this.props.tagType}
              onClose={() => this.setState({modal: "select"})}
            />
          )
        }

        {
          selectedTags.map(tag => (
            <div
              key={tag._id}
              onClick={() => { if (this.props.onClick) this.props.onClick(tag._id) }}
              className="Tag"
            >
              #{tag.name}
            </div>
          ))
        }

        <Button
          className="tagsEditButton"
          onClick={() => this.setState({ modal: "select" })}
          glyph="tag"
          bsSize="xsmall"
          tooltipText={getText("Seleccionar etiqueta")}
        />
      </div>
    )
  }

}

export default TagsList
